import HundredBricksAPIError from '../../../HundredBricksAPIError';
class InvestmentSimulationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('InvestmentSimulationError', ...args);
    }
}
export default InvestmentSimulationError;
